<div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12" style="padding-bottom: 3em;">
        <div class="pagination-area text-center">
            <button class="btn btn-sm" (click)="changePage(currentPage - 1)"
                [disabled]="currentPage === 1">Previous</button>
            &nbsp; &nbsp;<span>Page {{ currentPage }} of {{ totalPages }}</span> &nbsp; &nbsp;
            <button class="btn btn-sm" (click)="changePage(currentPage + 1)"
                [disabled]="currentPage === totalPages">Next</button>
        </div>
    </div>

</div>